import { httpRequest } from "../../http";

/**
 * Note that the signed-in user has opened this engagement (MPN-1720), or one page of it.
 *
 * Feeds the Last Visited column and the Recently Visited sort, which is the list's default
 * order and therefore most of what anyone sees when they land there.
 *
 * `surface` names the page. Passing "MONITOR" is what the ops dashboard's review-cadence
 * table counts (MPN-1858); omitting it means the engagement itself, as every call did
 * before that table existed.
 *
 * Fire and forget, and it swallows its own failures. This runs on the way into a page whose
 * actual job is showing the engagement; nobody should see an error, or wait, because a
 * convenience column could not be written. There is nothing to retry either -- the next open
 * overwrites it.
 */
export class CommandRecordEngagementView {
    async run(engagementId: number, surface?: "MONITOR"): Promise<void> {
        const query = surface ? `?surface=${surface}` : "";
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/viewed/${query}`;
        try {
            await httpRequest<unknown>(url, { method: "POST" });
        } catch (error) {
            console.warn("Could not record the engagement view", error);
        }
    }
}
